import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TagInputModule } from "ngx-chips";
import { CommonTLFModule } from '../../common/common.module';
import {
  FormAutoritaIndipendentiRegolatorieComponent
} from './form-autorita-indipendenti-regolatorie/form-autorita-indipendenti-regolatorie.component';
import {
  FormAutoritaIndipendentiRegolatorieViewComponent
} from "./form-autorita-indipendenti-regolatorie/view/form-autorita-indipendenti-regolatorie-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from './form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component';
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "./form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import { DynamicComponentService } from "./services/dynamic-component.service";

@NgModule({
    imports: [CommonTLFModule, CommonModule, RouterModule, NgbModule, FormsModule, ReactiveFormsModule, TagInputModule, NgSelectModule],
    declarations: [
        FormAutoritaIndipendentiRegolatorieComponent,
        FormAutoritaIndipendentiRegolatorieViewComponent,
        FormRecuperoCreditiStragiudizialeComponent,
        FormRecuperoCreditiStragiudizialeViewComponent
    ],
    providers: [DynamicComponentService],
    exports: [
        FormAutoritaIndipendentiRegolatorieComponent,
        FormAutoritaIndipendentiRegolatorieViewComponent,
        FormRecuperoCreditiStragiudizialeComponent,
        FormRecuperoCreditiStragiudizialeViewComponent
    ]
})
export class FascicoloFormSharedModule {

}
